module.exports = __webpack_public_path__ + "img/box.e644074a.png";